import { render, staticRenderFns } from "./SpaceUserCard.vue?vue&type=template&id=dc3d46ea&"
import script from "./SpaceUserCard.vue?vue&type=script&lang=js&"
export * from "./SpaceUserCard.vue?vue&type=script&lang=js&"
import style0 from "./SpaceUserCard.vue?vue&type=style&index=0&id=dc3d46ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports